import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getDistributions({ commit }) {
      try {
        const response = await api.get(`/distributions`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getDistribution({ commit }, id) {
      try {
        const response = await api.get(`/distributions/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async sendDistribution({ commit }, id) {
      try {
        const response = await api.post(`/distributions/${id}/send`)
        return response
      } catch (error) {
        throw error
      }
    },

    async deleteDistribution({ commit }, id) {
      try {
        const response = await api.delete(`/distributions/${id}`)
        return response
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
